import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AngularFireDatabase } from 'angularfire2/database';
import { WaiterOrderPage } from "../waiter-order/waiter-order";

@Component({
  selector: 'page-equests',
  templateUrl: 'Requests.html',
})
export class RequestsPage {
  user: any;
  userObj: any;
  orders: any = [];
  type: any;
  loading: boolean = true;
  constructor(public navCtrl: NavController, public navParams: NavParams, public af: AngularFireDatabase) {
    this.user = JSON.parse(localStorage.getItem('UserId'));
    this.userObj = JSON.parse(localStorage.getItem('UserObj'));
    this.type = this.navParams.get('type');
    let path = 'Orders/' + this.userObj.waiterTo;
    this.af.list(path, ref => {
      let obj = ref.orderByChild('waiterId').equalTo(this.user.uid);
      console.log(obj)
      return obj;

    }).snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    }).subscribe((res) => {
      this.orders = res;
      console.log(this.orders)
      this.loading = false;
    });
  }
  
  openOrder(order) {
    this.navCtrl.push(WaiterOrderPage, { order: order });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EquestsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/Requests/Requests.ts